import { SimCardServiceTypeItem } from '../../../../../interfaces/collections/SimCardServiceInterface';
import React, { FC, ReactElement } from 'react';
import { SimpleSelect } from '../../../../../components/Adescom/SimpleSelect';
import { FeaturesAction } from '../../../../../modules/features/reducers';
import GridItem from '../../../../../components/Grid/GridItem';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import I18n from '../../../../../components/Translate/I18n';

type SimCardTypeAwaitingActivationType = {
    checked: boolean;
    onChange: () => void;
};

export const SimCardTypeAwaitingActivation: FC<SimCardTypeAwaitingActivationType> = ({ checked, onChange }): ReactElement => {
    return (
        <>
            <GridItem xs={6}>
                <FormControlLabel
                    control={<Checkbox checked={checked} name="awaitingActivation" onChange={onChange} value={1} />}
                    label={<I18n trans="prov:feature.allow_waiting_activation" />}
                />
            </GridItem>
        </>
    );
};
